var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDocumentation(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22.424,
    height: 30.272,
    viewBox: "0 0 22.424 30.272",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-20 -9.5)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M42.05,9.5H23.364A3.367,3.367,0,0,0,20,12.864V32.3a2.619,2.619,0,0,0,2.616,2.616h8.6a.374.374,0,0,0,0-.747h-8.6a1.869,1.869,0,1,1,0-3.737h19.06v3.737h-.747a.374.374,0,1,0,0,.747H42.05a.374.374,0,0,0,.374-.374V9.874A.374.374,0,0,0,42.05,9.5ZM22.616,29.681a2.607,2.607,0,0,0-1.869.789V12.864a2.619,2.619,0,0,1,2.616-2.616H41.676V29.681ZM38.687,32.3H33.454a.374.374,0,0,0-.374.374V39.4a.374.374,0,0,0,.638.264l2.352-2.352,2.352,2.352a.374.374,0,0,0,.638-.264V32.671A.374.374,0,0,0,38.687,32.3Zm-.374,6.2-1.978-1.978a.374.374,0,0,0-.528,0L33.828,38.5V33.045h4.485ZM23.737,12.116v15.7a.374.374,0,0,1-.747,0v-15.7a.374.374,0,1,1,.747,0Z",
    fill: "#0080ff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentation);
export default __webpack_public_path__ + "static/media/documentation.1a216d7f.svg";
export { ForwardRef as ReactComponent };